module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loaded == false) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.loaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.discountList,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.created))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.request_status_display))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_vm._v(_vm._s(props.item.draft_reference))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_vm._v(_vm._s(props.item.quote_no))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_vm._v(_vm._s(props.item.metadata.customer_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_vm._v(_vm._s(props.item.metadata.requestor_user_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "12%"
          }
        }, [_vm._v(_vm._s(props.item.metadata.init_user_name))])]
      }
    }], null, false, 601131027)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}